import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

@Pipe({
  name: 'dataViewTimestampFormat',
  standalone: true,
})
export class DataViewTimestampFormatPipe implements PipeTransform {
  transform(timestamp: string | null | undefined, timezoneAbbr?: string): string {
    // Return 'NA' if timestamp is null, undefined, empty, or 'NA'
    if (!timestamp || timestamp === 'NA' || timestamp === 'null') {
      return 'NA';
    }

    // Convert to string and trim
    const timestampStr = String(timestamp).trim();
    if (timestampStr === '') {
      return 'NA';
    }

    try {
      // Parse the timestamp string (e.g., "2025-02-10T02:21:28")
      // dayjs will parse ISO format strings correctly
      const date = dayjs(timestampStr);

      // Check if the date is valid
      if (!date.isValid()) {
        // console.warn('DataViewTimestampFormatPipe: Invalid date value:', timestamp);
        return 'NA';
      }

      // Format: "10 Feb 2025 2:21:28 PM"
      const day = date.format('D'); // Day without leading zero (1-31)
      const month = date.format('MMM'); // Short month name (Jan, Feb, etc.)
      const year = date.format('YYYY'); // Full year
      const hour = date.format('h'); // Hour in 12-hour format without leading zero
      const minute = date.format('mm'); // Minutes with leading zero
      const second = date.format('ss'); // Seconds with leading zero
      const ampm = date.format('A'); // AM/PM

      // Build the formatted string
      let formattedDate = `${day} ${month} ${year} ${hour}:${minute}:${second} ${ampm}`;

      // Append timezone if provided
      if (timezoneAbbr && String(timezoneAbbr).trim() !== '') {
        formattedDate += ` ${String(timezoneAbbr).trim()}`;
      }

      return formattedDate;
    } catch (error) {
      console.error('Error in DataViewTimestampFormatPipe:', error);
      return 'NA';
    }
  }
}

